import { pencilIcon } from '@progress/kendo-svg-icons';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionModel } from 'app/models/session.model';
import { MembershipService } from 'app/core/services/membership.service';
import { EventService } from 'app/core/services/event.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { PropertyProviderDisplaySetModel } from 'app/models/property-provider-display-set.model';

@Component({
  standalone: false,
  selector: 'app-property-providers',
  templateUrl: './property-providers.component.html',
  styleUrls: ['./property-providers.component.scss']
})
export class PropertyProvidersComponent extends NexusComponent {
  pencilIcon = pencilIcon;
  public property_providers_model: Array<PropertyProviderDisplaySetModel>;
  public session: SessionModel = null; 

  constructor(private route: ActivatedRoute, public membership: MembershipService, public event_service: EventService) {
    super();
    this.event_service.on('session-start', (model) => {
        this.session = model;
    });
    this.event_service.on('session-end', () => {
        this.session = null;
    });
   }

  ngOnInit(): void {
    this.membership.GetSession().subscribe(
      data => {
        this.session = data;
      },
      error => {
        this.session = null;
      });

    this.route.data.subscribe(({property_providers_model}) => {
      this.property_providers_model = property_providers_model;
  });
}
}
